export default {
  data: () => ({ isHeaderHidden: false, rootEl: null, orignalValue: false }),

  mounted() {
    // Use nextTick to ensure DOM is fully rendered
    this.$nextTick(() => {
      this.initializeHeaderHiding();
    });
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    initializeHeaderHiding() {
      this.rootEl = document.querySelector("[data-with-center-search=true]");
      if (!this.rootEl) {
        return;
      }
      this.orignalValue = this.rootEl.getAttribute("data-with-center-search");
      const header = document.querySelector(".site-header");
      if (!header) return false;

      this.toggleHeader(this.isOverlapping());
      window.addEventListener("scroll", this.throttledScrollCheck, {
        passive: true,
      });
    },

    isOverlapping() {
      const header = document.querySelector(".site-header");
      const headerRect = header.getBoundingClientRect();
      const targetRect = this.$el.getBoundingClientRect();
      const searchResult = document.querySelector(".search-bar-center-result");

      return (
        targetRect.top <= headerRect.bottom + 5 &&
        targetRect.bottom >= headerRect.top - 5 &&
        targetRect.left < headerRect.right &&
        targetRect.right > headerRect.left &&
        (!searchResult || searchResult.offsetParent === null)
      );
    },

    throttledScrollCheck: (() => {
      let isThrottled = false;
      return function () {
        if (isThrottled) return;

        isThrottled = true;
        requestAnimationFrame(() => {
          this.toggleHeader(this.isOverlapping());
          isThrottled = false;
        });
      };
    })(),

    toggleHeader(shouldHide) {
      if (this.isHeaderHidden === shouldHide) return;

      this.isHeaderHidden = shouldHide;

      requestAnimationFrame(() => {
        if (!this.rootEl) return;

        const hasCenterSearch = document.querySelector(
          "[data-with-center-search=true]"
        );
        const newValue = shouldHide && hasCenterSearch ? "false" : "true";

        this.rootEl.setAttribute("data-with-center-search", newValue);
      });
    },

    cleanup() {
      this.rootEl?.setAttribute("data-with-center-search", this.orignalValue);
      window.removeEventListener("scroll", this.throttledScrollCheck, {
        passive: true,
      });
    },

    reinitialize() {
      this.cleanup();
      this.$nextTick(() => {
        this.initializeHeaderHiding();
      });
    },
  },
};
